<script setup>
import { NodeViewContent, nodeViewProps, NodeViewWrapper } from "@tiptap/vue-3"
import EditableNodeWrapper from "@/Components/Inputs/BlockEditor/Extension/Components/EditableNodeWrapper.vue"
import { computed, ref } from "vue"
import Grid from "@/Components/Inputs/BlockEditor/Extension/Components/Grid.vue"
import EditGrid from "@/Components/Inputs/BlockEditor/Extension/Modals/EditGrid.vue"
import useNodeProps from "@/Composables/useNodeProps.js"
import AuctionCardPreview from "@/Components/Inputs/BlockEditor/Extension/Components/Auctions/AuctionCardPreview.vue"
import EditAlgoliaFilters from "@/Components/Inputs/BlockEditor/Extension/Modals/EditAlgoliaFilters.vue"

const props = defineProps({
  ...nodeViewProps,
})

let {
  state,
  ids,
  cols,
  spacing,
} = useNodeProps(props)

const options = computed(() => {
  return props.extension.options
})

let items = ref([]);

const onHitsUpdated = (hits) => {
  // update collection
  items.value = hits

  // update node prop
  ids.value = hits.map(item => item.id)
}
</script>

<template>
  <node-view-wrapper>
    <EditableNodeWrapper v-bind="props">
      <template #tools>
        <EditGrid
          v-model:cols="cols"
          v-model:spacing="spacing"
        />
        <EditAlgoliaFilters
          v-model:state="state"
          :default-index="options.defaultIndex"
          :index-options="options.indexOptions"
          :variant-filters="options.variantFilters"
          @hits="onHitsUpdated"
        />
      </template>
      <template #content>
        <div class="w-full">
          <div class="flex w-full">
            <node-view-content class="first:prose-headings:mt-2"/>
          </div>
          <Grid :cols="cols" :spacing="spacing">
            <AuctionCardPreview v-for="auction in items" :auction="auction" />
          </Grid>
        </div>
      </template>
    </EditableNodeWrapper>
  </node-view-wrapper>
</template>
